import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from './../../shared';

@Component({
  selector: 'api-data-on-demand',
  template: require('./api.component.html'),
  styles: [require('./api.component.scss'), require('.//../static.scss')]
})
export class ApiComponent implements AfterViewInit {
  title = 'API - Linescape';
  description = 'Data feeds by API save you the trouble of hosting data on your system and allow you to get any data in real-time, whenever you need it, one search at a time.';

  constructor(private route: ActivatedRoute, private seo: SeoService) {
    // Do stuff
  }

  ngAfterViewInit() {
    this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/api/api.component.ts